'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', '\n  display: inline-block;\n  border-radius: 2px;\n  cursor: pointer;\n  text-decoration: none;\n'], ['\n  ', '\n  ', '\n  ', '\n  display: inline-block;\n  border-radius: 2px;\n  cursor: pointer;\n  text-decoration: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.a.withConfig({
  displayName: 'Button',
  componentId: 'sc-2ddgc-0'
})(_templateObject, function (props) {
  return props.margin && 'margin: ' + props.margin + ';';
}, function (props) {
  return props.padding && 'padding: ' + props.padding + ';';
}, function (props) {
  return props.width && 'width: ' + props.width + 'px; height: ' + props.width + 'px;';
});

Button.defaultProps = {
  width: 33,
  margin: "0 6px 0 0",
  padding: "0"
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Button.js
// module id = 58
// module chunks = 168707334958949